import React, { useState, useEffect, useRef } from "react";
import { Form, ListGroup, Spinner } from "react-bootstrap";
import { searchSchemesPublic } from "../../intakeApi";

export function SchemeSearchPublic({ value, onChange, isInvalid }) {
  const [query, setQuery] = useState(value?.name || "");
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const debounceRef = useRef(null);
  const wrapperRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    function handleClick(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  function handleInput(e) {
    const q = e.target.value;
    setQuery(q);
    onChange(null); // clear selected scheme

    if (q.length < 3) {
      setResults([]);
      setShowDropdown(false);
      return;
    }

    clearTimeout(debounceRef.current);
    debounceRef.current = setTimeout(async () => {
      setLoading(true);
      const data = await searchSchemesPublic(q);
      setResults(data);
      setShowDropdown(data.length > 0);
      setLoading(false);
    }, 300);
  }

  function handleSelect(scheme) {
    setQuery(scheme.name);
    setShowDropdown(false);
    setResults([]);
    onChange(scheme);
  }

  return (
    <div ref={wrapperRef} style={{ position: "relative" }}>
      <div style={{ position: "relative" }}>
        <Form.Control
          type="text"
          placeholder="Type to search medical aid..."
          value={query}
          onChange={handleInput}
          isInvalid={isInvalid}
          autoComplete="off"
        />
        {loading && (
          <Spinner
            size="sm"
            animation="border"
            style={{ position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)" }}
          />
        )}
      </div>
      {showDropdown && (
        <ListGroup
          style={{
            position: "absolute",
            zIndex: 1000,
            width: "100%",
            maxHeight: 220,
            overflowY: "auto",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          {results.map((s) => (
            <ListGroup.Item
              key={s.code}
              action
              onClick={() => handleSelect(s)}
              style={{ cursor: "pointer" }}
            >
              {s.name}
            </ListGroup.Item>
          ))}
        </ListGroup>
      )}
    </div>
  );
}
